<template>
    <editor :init="init" v-model="editorValue"></editor>
</template>
<script>
import { uploadFile } from "../http/api";
import qs from "qs";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver";
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/icons/default";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/image";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/hr";
import "tinymce/plugins/paste";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/preview";
import "tinymce/plugins/autolink";
import "tinymce/plugins/lineheight/plugin";
export default {
    name: "tinymce",
    components: {
        Editor,
    },
    props: {
        value: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            editorValue: this.value,
            init: {
                language_url: "/tinymce/languages/zh_CN.js",
                language: "zh_CN",
                height: 500,
                max_width: 800,
                skin_url: "/tinymce/skins/ui/oxide",
                menubar: false, //隐藏菜单栏
                plugins: "link lists image code table wordcount hr paste searchreplace fullscreen lineheight preview autolink ",
                toolbar: [
                    ` undo redo | fontsizeselect | blockquote hr | link unlink image | table | searchreplace code fullscreen`,
                    ` bold italic underline strikethrough |  forecolor backcolor 
                    | alignleft aligncenter alignright alignjustify |  bullist numlist | outdent indent lineheight | removeformat preview`,
                ],
                fontsize_formats: "12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px",
                branding: false,
                forced_root_block: "div",
                paste_data_images: true,
                image_description: false, // img title
                image_dimensions: false, // img size
                formats: {
                    // aligncenter: {
                    //     selector: "img",
                    //     attributes: { width: "90%", height: "90%" },
                    //     styles: { display: "block", marginRight: "auto", marginLeft: "auto" },
                    // },
                    // alignleft:{selector:'div',attributes:{},styles:{padding:'0 10px'}},
                },
                content_style: `img{display:block; max-width: 100%; margin: 8px auto;}`,
                paste_postprocess: function(plugin, args) {
                    var tables = args.node.getElementsByTagName("table");
                    for (var i = 0; i < tables.length; i++) {
                        tables[i].setAttribute("border", "1");
                        tables[i].style.borderCollapse = "collapse";
                    }
                },
                images_upload_handler: function(blobInfo, success, failure) {
                    var file = blobInfo.blob();
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onloadend = function() {
                        // if (file.size > 1048576) {
                        //     failure("图片请不要大于 1MB");
                        // } else {
                        let formData = new FormData();
                        formData.append("files", file);
                        formData.append("type", "editor");
                        uploadFile(formData).then((res) => {
                            console.log(res);
                            success(res.data.result[0].fileUrl);
                        });
                        // let base = reader.result.split(",")[1];
                        // let imgType = reader.result
                        //     .split(",")[0]
                        //     .replace("data:image/", "")
                        //     .replace(";base64", "");
                        // let imgName = +new Date() + "_" + parseInt(Math.random() * 900000 + 100000) + "." + imgType;
                        // uploadImg({
                        //     imgBase64: base,
                        //     imgPath: imgName,
                        // }).then((res) => {
                        //     success(res.data.data);
                        // });
                        // };
                    };
                },
            },
        };
    },
    methods: {},
    watch: {
        editorValue(newValue) {
            this.$emit("input", newValue);
        },
        value(newValue) {
            this.editorValue = newValue;
        },
    },
};
</script>
